import axios from "axios";
import { messageCountry } from "../App";
import { translations } from "./data";
import settings from "../../package.json";

export const convertUnixTimestamp = (unixTimestamp) => {
  const day = new Date(unixTimestamp * 1000);
  const months = [
    "01",
    "02",
    "03",
    "04",
    "05",
    "06",
    "07",
    "08",
    "09",
    "10",
    "11",
    "12",
  ];
  const year = day.getFullYear();
  const month = months[day.getMonth()];
  const date = day.getDate();
  const hour = day.getHours();
  const min = day.getMinutes();
  // const sec = day.getSeconds();
  const time = `${year}/${month}/${date} ${hour}:${min}`;

  return time;
};

const getType = (parameterType) => {
  switch (parameterType) {
    case "TEXT":
      return "Text";
    case "INTEGER":
      return "Number";
    case "DECIMAL":
      return "Decimal";
    case "BOOLEAN":
      return "Boolean(True/False)";
    case "LIST":
      return "List";
    case "MULTILIST":
      return "Multiple-Selection List";
    default:
      return parameterType;
  }
};

export const parameterLookUp = (parameterSet, parameters) => {
  const newArray = [];

  parameterSet.forEach((e) => {
    let values;
    const newValue = [];

    const value = parameters[e.id];

    if (value !== undefined) {
      value.forEach((e) => {
        const newFile = {
          ...e,
          formattedType: getType(e.type),
        };
        newValue.push(newFile);
      });
      values = newValue;
    } else {
      values = [];
    }

    const newData = {
      ...e,
      values,
    };
    newArray.push(newData);
  });

  return newArray;
};

export const groupParamterValues = (array) => {
  let result;
  if (array.length === 0) {
    result = [];
  } else {
    result = array.reduce((r, a) => {
      r[a.dataset_id] = r[a.dataset_id] || [];
      r[a.dataset_id].push(a);

      return r;
    }, Object.create(null));
  }

  return result;
};

const getStatus = (status) => {
  switch (status) {
    case "ARCHIVED":
      return "Archived";
    case "NO_LONGER_ORDERED":
      return "No longer ordered";
    case "NOT_FOR_SALE":
      return "Not for sale";
    default:
      return "Active";
  }
};

const getProductType = (type) => {
  switch (type) {
    case "MATRIX":
      return "Matrix product";
    case "BUNDLE":
      return "Bundle";
    case "ASSEMBLY":
      return "Assembly";
    default:
      return "Product";
  }
};

export const matchBrandsAndProductGroup = (
  products,
  productGroups,
  productCategories
) => {
  let newArray = [];
  products.forEach((product) => {
    const newData = {
      ...product,
      formattedStatus: getStatus(product.status),
      formattedType: getProductType(product.type),
    };
    newArray.push(newData);
  });
  return newArray;
};

export const requestERPLYData = (requestData) => {
  const requestFormData = new FormData();
  Object.entries(requestData).forEach((fieldValue) => {
    const [key, value] = fieldValue;
    requestFormData.set(`${key}`, `${value}`);
  });
  const options = {
    method: "post",
    headers: { "Content-type": "multipart/form-data" },
    url: `https://${requestData.clientCode}.erply.com/api/`,
    data: requestFormData,
  };
  return axios(options);
};

export const findGroupId = (productGroup, name) => {
  return productGroup.find((group) => group.name.en === name);
};

export const getResponseData = (arry) => {
  const newArry = [];

  arry.forEach((ele) => {
    if (ele.records.length) {
      ele.records.forEach((rec) => {
        newArry.push({ ...rec, id: parseInt(rec.id, 10) });
      });
    }
  });

  return newArry;
};

export const createRequestData = (requestLength, requestBody) => {
  const {
    requestName,
    recordsOnPage,
    stocktakingID,
    getFIFOCost,
    productIDs,
    promotionIDs,
    sendContentType,
    orderByDir,
  } = requestBody;
  const newArray = [];
  let pageNo = 1;
  let requestID = 1;
  for (let index = 0; index < requestLength; index++) {
    if (stocktakingID) {
      newArray.push({
        requestName,
        recordsOnPage,
        pageNo,
        sendContentType,
        requestID,
        stocktakingID,
        partnerKey,
      });
      pageNo++;
      requestID++;
    } else if (getFIFOCost) {
      newArray.push({
        requestName,
        recordsOnPage,
        pageNo,
        sendContentType,
        requestID,
        getFIFOCost,
        productIDs,
        partnerKey,
      });
      pageNo++;
      requestID++;
    } else if (promotionIDs) {
      newArray.push({
        requestName,
        recordsOnPage,
        pageNo,
        promotionIDs,
        requestID,
        sendContentType,
        partnerKey,
      });
      pageNo++;
      requestID++;
    } else if (orderByDir) {
      newArray.push({
        requestName,
        recordsOnPage,
        pageNo,
        requestID,
        sendContentType,
        orderByDir,
        partnerKey,
      });
      pageNo++;
      requestID++;
    } else {
      newArray.push({
        requestName,
        recordsOnPage,
        pageNo,
        requestID,
        sendContentType,
        partnerKey,
      });
      pageNo++;
      requestID++;
    }
  }

  const jsonFile = JSON.stringify(newArray);

  return jsonFile;
};

export const formartCompayTypes = (companyTypes) => {
  const newArray = [];

  companyTypes.forEach((type) => {
    let name = "";
    if (type.name === "public limited company") {
      name = `AS(${type.name})`;
    } else if (type.name === "private limited company") {
      name = `OÜ(${type.name})`;
    } else if (type.name === "non-profit association") {
      name = `MTÜ(${type.name})`;
    } else if (type.name === "foundation") {
      name = `SA(${type.name})`;
    } else {
      name = `${type.name}`;
    }
    newArray.push({ ...type, name });
  });

  return newArray;
};

export const getTranslation = (translationCode, lang) => {
  const translationObject = translations.find(
    ({ code }) => code === translationCode
  );

  if (translationObject) {
    if (lang === "eng") {
      return replaceTranslationKey(translationObject.name.en);
    } else if (lang === "est") {
      if (translationObject.name.et) {
        return translationObject.name.et;
      } else {
        return replaceTranslationKey(translationObject.name.en);
      }
    } else if (lang === "fin") {
      if (translationObject.name.fi) {
        return translationObject.name.fi;
      } else {
        return replaceTranslationKey(translationObject.name.en);
      }
    } else return replaceTranslationKey(translationObject.name.en);
  } else {
    return translationCode;
  }
};

export const partnerKey = "b82a2fb260b022af11e4ed51ad600ba9678135a7";

export const setEditingState = (languages, data, field) => {
  const state = {};

  languages.forEach((lang) => {
    const { isoCode } = lang;
    if (data && data[field][isoCode]) {
      state[isoCode] = data[field][isoCode];
    } else {
      state[isoCode] = "";
    }
  });

  return state;
};

export const replaceTranslationKey = (translation) => {
  if (translation.includes("{TAX}") || translation.includes("{tax}")) {
    const isCapitalize = translation.includes("{TAX}");
    if (messageCountry === "CA" || messageCountry === "US") {
      if (isCapitalize) {
        return translation.replace("{TAX}", "Tax");
      }
      return translation.replace("{tax}", "tax");
    } else if (
      messageCountry === "AU" ||
      messageCountry === "NZ" ||
      messageCountry === "SG"
    ) {
      if (isCapitalize) {
        return translation.replace("{TAX}", "GST");
      }
      return translation.replace("{tax}", "GST");
    } else {
      if (isCapitalize) {
        return translation.replace("{TAX}", "VAT");
      }
      return translation.replace("{tax}", "VAT");
    }
  } else {
    return translation;
  }
};

export const formularTypes = [
  {
    type: "SPECIAL_PRICE_WITH_BULK_PURCHASE",
    value: "Special Price With Bulk Purchase",
  },
  {
    type: "DISCOUNT_WITH_BULK_PURCHASE",
    value: "Discount With Bulk Purchase",
  },
  {
    type: "BUY_ONE_GET_ONE",
    value: "Buy One Get One",
  },
  {
    type: "SPEND_AND_GET",
    value: "Spend And Get",
  },
  { type: "BUNDLE_PRICE", value: "Bundle Price" },
  {
    type: "GET_DISCOUNT_FOR_LOYALTY_POINTS",
    value: "Get Discount For Loyalty Points",
  },

  {
    type: "BUY_AND_GET_PERCENTAGE_OFF_EVERYTHING",
    value: "Buy And Get Percentage Off Everything ",
  },
  {
    type: "SPEND_AND_GET_PERCENTAGE_OFF_EVERYTHING",
    value: "Spend And Get Percentage Off Everything",
  },

  {
    type: "BUY_AND_GET_SUM_OFF_YOUR_PURCHASE",
    value: "Buy And Get Sum Off Your Purchase",
  },
  {
    type: "SPEND_AND_GET_SUM_OFF_YOUR_PURCHASE",
    value: "Spend And Get Sum Off Your Purchase",
  },
  {
    type: "PAY_WITH_LOYALTY_POINTS",
    value: "Pay With Loyalty Points",
  },
];

const getPromotion = async (campaignID, keys) => {
  const requestBody = {
    sessionKey: keys.sessionKey,
    clientCode: keys.clientCode,
    partnerKey,
    sendContentType: 1,
    request: "getCampaigns",
    campaignID,
  };

  try {
    const { data } = await requestERPLYData(requestBody);
    if (data.status.responseStatus === "error") {
      return "";
    } else {
      const promotion = data.records[0];
      const formula = formularTypes.find((e) => e.type === promotion.formula);

      if (formula) {
        return formula.value;
      }

      return promotion.formula;
    }
  } catch (error) {
    return "";
  }
};

const formatNumber = (x) => {
  return x ? Number.parseFloat(x).toFixed(2) : "";
};

export const formatDiscountValues = (row, quantity, keys) => {
  const result = {};

  Object.entries(row).forEach(async (fieldValue) => {
    const [key, value] = fieldValue;
    const lastChar = key.slice(-1);
    const formarted = parseInt(lastChar, 10);

    if (!isNaN(formarted)) {
      if (result[lastChar]) {
        const discountType = result[lastChar]?.source;
        if (key === `promotionRule1priceListID${lastChar}`) {
          if (value > 0) {
            result[lastChar]["source"] = "Price List";
          }
        }
        if (key === `promotionRule1campaignID${lastChar}` && value > 0) {
          result[lastChar]["source"] = "Promotion";
        }

        if (key === `promotionRule1priceListDiscountType${lastChar}`) {
          if (discountType) {
            if (discountType === "Price List") {
              if (value === "PRICE") {
                result[lastChar]["type"] = "Special Price";
              } else if (value === "DISCOUNT") {
                result[lastChar]["type"] = "Product Group Discount";
              }
            } else {
              if (!result[lastChar]["type"]) {
                const id = row[`promotionRule1campaignID${lastChar}`];
                const formula = await getPromotion(id, keys);
                result[lastChar]["type"] = formula;
              }
            }
          }
        }
        if (key === `promotionRule1name${lastChar}`) {
          result[lastChar]["name"] = value;
        }
        if (discountType) {
          if (discountType === "Price List") {
            const type = row[`promotionRule1priceListDiscountType${lastChar}`];
            if (type && type === "PRICE") {
              const total =
                row[`promotionRule1finalPrice${lastChar}`] /
                row[`promotionRule1amount${lastChar}`];
              result[lastChar]["priceDiscount"] = formatNumber(total || 0);
            } else if (type && type === "DISCOUNT") {
              const priceDiscount = `-${
                row[`promotionRule1priceListDiscountPercentage${lastChar}`]
              }% * ${row[`promotionRule1amount${lastChar}`]}`;
              result[lastChar]["priceDiscount"] = priceDiscount;
            }
          } else {
            const campaignDiscountPercentage =
              row[`promotionRule1campaignDiscountPercentage${lastChar}`];
            if (campaignDiscountPercentage) {
              const priceDiscount = `-${campaignDiscountPercentage}% * ${
                row[`promotionRule1amount${lastChar}`]
              }`;
              result[lastChar]["priceDiscount"] = priceDiscount;
            } else {
              const campignType = row[`promotionRule1campaignType${lastChar}`];
              if (campignType) {
                if (campignType === "ITEMS") {
                  const total =
                    row[`promotionRule1totalDiscount${lastChar}`] /
                    row[`promotionRule1amount${lastChar}`];
                  result[lastChar]["priceDiscount"] = `-${formatNumber(
                    total || 0
                  )} * ${row[`promotionRule1amount${lastChar}`]}`;
                } else if (campignType === "INVOICE") {
                  result[lastChar]["priceDiscount"] = `-${
                    row[`promotionRule1totalDiscount${lastChar}`]
                  }`;
                }
              }
            }
          }
        }

        if (formarted === 1) {
          const total = row["originalPrice"] * parseInt(row["amount"], 10);
          result[lastChar]["total"] = total;
          if (total) {
            result[lastChar]["newUnitPrice"] = total / quantity;
          }
        } else {
          const prev = parseInt(lastChar, 10) - 1;
          const prevTotal = result[prev]?.total;
          if (prevTotal) {
            const total =
              prevTotal - row[`promotionRule1totalDiscount${lastChar}`];
            result[lastChar]["total"] = total;
            if (total) {
              result[lastChar]["newUnitPrice"] = total / quantity;
            }
          }
        }
      } else {
        result[lastChar] = {
          source: "",
          type: "",
          name: "",
          priceDiscount: "",
          total: "",
          newUnitPrice: "",
        };
        const discountType = result[lastChar].source;
        if (key === `promotionRule1priceListID${lastChar}`) {
          if (value > 0) {
            result[lastChar]["source"] = "Price List";
          }
        }
        if (key === `promotionRule1campaignID${lastChar}` && value > 0) {
          result[lastChar]["source"] = "Promotion";
        }
        if (key === `promotionRule1priceListDiscountType${lastChar}`) {
          if (discountType) {
            if (discountType === "Price List") {
              if (value === "PRICE") {
                result[lastChar]["type"] = "Special Price";
              } else if (value === "DISCOUNT") {
                result[lastChar]["type"] = "Product Group Discount";
              }
            } else {
              const id = row[`promotionRule1campaignID${lastChar}`];
              const formula = await getPromotion(id, keys);
              result[lastChar]["type"] = formula;
            }
          }
        }

        if (key === `promotionRule1name${lastChar}`) {
          result[lastChar]["name"] = value;
        }

        if (discountType) {
          if (discountType === "Price List") {
            const type = row[`promotionRule1priceListDiscountType${lastChar}`];
            if (type && type === "PRICE") {
              const total =
                row[`promotionRule1finalPrice${lastChar}`] /
                row[`promotionRule1amount${lastChar}`];
              result[lastChar]["priceDiscount"] = formatNumber(total || 0);
            } else if (type && type === "DISCOUNT") {
              const priceDiscount = `-${
                row[`promotionRule1priceListDiscountPercentage${lastChar}`]
              }% * ${row[`promotionRule1amount${lastChar}`]}`;
              result[lastChar]["priceDiscount"] = priceDiscount;
            }
          } else {
            const campaignDiscountPercentage =
              row[`promotionRule1campaignDiscountPercentage${lastChar}`];
            if (campaignDiscountPercentage) {
              const priceDiscount = `-${campaignDiscountPercentage}% * ${
                row[`promotionRule1amount${lastChar}`]
              }`;
              result[lastChar]["priceDiscount"] = priceDiscount;
            } else {
              const campignType = row[`promotionRule1campaignType${lastChar}`];
              if (campignType) {
                if (campignType === "ITEMS") {
                  const total =
                    row[`promotionRule1totalDiscount${lastChar}`] /
                    row[`promotionRule1amount${lastChar}`];
                  result[lastChar]["priceDiscount"] = `-${formatNumber(
                    total || 0
                  )} * ${row[`promotionRule1amount${lastChar}`]}`;
                } else if (campignType === "INVOICE") {
                  result[lastChar]["priceDiscount"] = `-${
                    row[`promotionRule1totalDiscount${lastChar}`]
                  }`;
                }
              }
            }
          }
        }

        if (formarted === 1) {
          const total = row["originalPrice"] * parseInt(row["amount"], 10);
          result[lastChar]["total"] = total;
          if (total) {
            result[lastChar]["newUnitPrice"] = formatNumber;
          }
        } else {
          const prev = parseInt(lastChar, 10) - 1;
          const prevTotal = result[prev]?.total;
          if (prevTotal) {
            const total =
              prevTotal - row[`promotionRule1totalDiscount${lastChar}`];
            result[lastChar]["total"] = total;
            if (total) {
              result[lastChar]["newUnitPrice"] = total / quantity;
            }
          }
        }
      }
    }
  });

  return result;
};

export const getReleaseInfo = () => {
  const { date, version } = settings;
  if (date === "DATE") {
    return {
      time: null,
      version,
    };
  }
  return {
    time: new Date(date).toDateString(),
    version,
  };
};

// {
//   "rowNumber": 1,
//   "productID": "1379",
//   "amount": "1",
//   "vatrateID": 2,
//   "vatRate": "9",
//   "originalPrice": 210,
//   "originalPriceWithVAT": 228.9,
//   "manualDiscountPrice": 0,
//   "manualDiscountPriceWithVAT": 0,
//   "manualDiscountReasonCodeID": 0,
//   "promotionPrice": 210,
//   "promotionPriceWithVAT": 228.9,
//   "promotionDiscount": 0,
//   "originalDiscount": 0,
//   "manualDiscount": 0,
//   "discount": 0,
//   "finalPrice": 210,
//   "finalPriceWithVAT": 228.9,
//   "rowNetTotal": 210,
//   "rowVAT": 18.900000000000006,
//   "rowTotal": 228.9,
//   "priceBasedTaxThreshold": null,
//   "priceBasedTaxRate": null,
//   "nonDiscountable": 0,
//   "promotionRule1priceListID1": 4,
//   "promotionRule1name1": "Dev test",
//   "promotionRule1amount1": 1,
//   "promotionRule1finalPrice1": 228.9,
//   "promotionRule1totalDiscount1": 534.1,
//   "promotionRule1priceListDiscountType1": "DISCOUNT",
//   "promotionRule1priceListDiscountPercentage1": "70"
// }

export const languageMap = {
  eng: "en",
  est: "et",
  lat: "lv",
  rus: "ru",
  fin: "fi",
  gre: "el",
  spa: "es",
  ger: "de",
  swe: "sv",
  lit: "lt",
};
